
function ScrollingImage(){

    this.build();
    resizeCallbacks.push( this );

}

ScrollingImage.prototype.build = function() {

    this.resize();

};

ScrollingImage.prototype.resize = function(){

    $('.image-scrolling').each(function(){

        let element = $(this);
        let image = element.find('.image-scrolling__parallax');
        let trigger = $('.scrolling-image-container');

        let end = element.data('parallax-end');

        if( window.innerWidth > 768 ) {
            gsap.to(element, {
                y: end,
                ease: 'none',
                scrollTrigger: {
                    trigger: trigger,
                    start: 'top center',
                    end: 'bottom top',
                    scrub: true
                }
            });
        }

        gsap.to( image, {
            y: '20%',
            ease: 'none',
            scrollTrigger: {
                trigger: trigger,
                start: 'top center',
                end: 'bottom top',
                scrub: true
            }
        });


    });

};
